import {Select} from "@/theme";
import {useApi} from "@/lib/hook";

export const RoleSelect = ({...rest}) => {
    const {data} = useApi({
        route: {name: 'authorization.roles'},
        data: {
            include: 'permissions',
        },
        setting: {
            select: (resp) => resp.data,
            staleTime: Infinity,
        }
    })

    return (
        <>
            <Select
                fieldNames={{value: 'name', label: 'title'}}
                options={data ?? []}
                {...rest}
            />
        </>
    );
}